export class AssetReportDetailModel {
    constructor() {
        this.id = "";
        this.assetTypeId = "";
        this.assetType = "";
        this.assetCategory = "";
        this.assetCode = "";
        this.name = "";
        this.dateOfPurchase = "";
        this.dateOfPurchaseAsString = "";
        this.price = null;
    }
}
export default class AssetReportDetail extends AssetReportDetailModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
